import React from 'react';
import { Row, Col, Image, Space, Typography, Timeline, Grid } from 'antd';
import Chair from '../../assets/img/chair.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Dates() {
  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Text style={{ fontSize: 22, fontWeight: 'bold' }}>Important Dates</Text>
            </Col>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Chair}
                preview={false}
                style={{ objectFit: 'cover', float: 'right' }}
              />
            </Col>
            <Col span={24}>
              <Timeline>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 10, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Abstract Submission Deadline</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 5, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Early Bird Payment Deadline</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 20, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Regular Payment Deadline</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 15, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Notification of Acceptances</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 28, 2022 - October 29, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Conference Date</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>November 11, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Full Paper Submission</Text>
                  </Space>
                </Timeline.Item>
                {/* <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>November 28, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Notification of Full Paper</Text>
                  </Space>
                </Timeline.Item> */}
              </Timeline>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
            <Col span={24} style={{ paddingBottom: 64, textAlign: 'center' }}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Important Dates</Text>
            </Col>
            <Col span={12}>
              <Timeline>
              <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 10, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Abstract Submission Deadline</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 5, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Early Bird Payment Deadline</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 20, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Regular Payment Deadline</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 15, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Notification of Acceptances</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>October 28, 2022 - October 29, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Conference Date</Text>
                  </Space>
                </Timeline.Item>
                <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>November 11, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Full Paper Submission</Text>
                  </Space>
                </Timeline.Item>
                {/* <Timeline.Item>
                  <Space direction='vertical' size={0}>
                    <Text style={{ fontSize: 16, color: '#0D6E49' }}>November 28, 2022</Text>
                    <Text style={{ fontSize: 17, fontWeight: 500 }}>Notification of Full Paper</Text>
                  </Space>
                </Timeline.Item> */}
              </Timeline>
            </Col>
            <Col span={3}></Col>
            <Col span={9}>
              <Image
                width={'100%'}
                src={Chair}
                preview={false}
                style={{ objectFit: 'cover', float: 'right' }}
              />
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Dates